module.exports = __webpack_public_path__ + "img/cutlery.d5a5cf79.svg";